import { LIFESTYLE_KEYS } from "@./cat-calculations";
import { snakeCaseToCamelCase } from "@utils/misc";
import { useTranslations } from "next-intl";
import { createEnumTranslations } from "./createEnumTranslations";

export const useCatLifestyle = () => {
  const tLifestyles = useTranslations("Cats.LifeStyles");
  const tVocabulary = useTranslations("Shared.Vocabulary");
  const unknown = tVocabulary("unknown");

  return createEnumTranslations({
    values: LIFESTYLE_KEYS,
    translate: (lifestyle) => {
      if (lifestyle === "UNKNOWN") {
        return unknown;
      }

      return tLifestyles(`${snakeCaseToCamelCase(lifestyle)}.title`);
    },
    translateDescription: (lifestyle) => {
      if (lifestyle === "UNKNOWN") {
        return unknown;
      }

      return tLifestyles(`${snakeCaseToCamelCase(lifestyle)}.description`);
    },
    fallback: unknown,
  });
};
